import * as React from 'react'

function SvgPlayerAirplay(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M6.5 21.1h10.8l-5.4-5.4-5.4 5.4zM20 4H3.8C2.81 4 2 4.81 2 5.8v10.8c0 .99.81 1.8 1.8 1.8h3.6v-1.8H3.8V5.8H20v10.8h-3.6v1.8H20c.99 0 1.8-.81 1.8-1.8V5.8c0-.99-.81-1.8-1.8-1.8z" />
    </svg>
  )
}

export default SvgPlayerAirplay
